// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__tEOF0","container":"styles_container__TTTIx","title":"styles_title__2-g81","wrapper":"styles_wrapper__1g2f6","answer":"styles_answer__2A5-h"};